module.exports = "/assets/without-account-active@2x.png?5XoWBXT";